import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, mediaQuery } from '../../../styles';

export default createUseStyles<
  string,
  { whiteText: boolean; withLayoutBackground?: boolean },
  ITheme
>(
  ({ breakpoints, layout }: ITheme) => ({
    root: {
      height: 52,
      backgroundColor: ({ withLayoutBackground }) =>
        withLayoutBackground ? layout.background : 'transparent',
      width: '100%',
    },
    container: {
      paddingTop: 12,
      width: '100%',
      maxWidth: 1360,
      margin: 'auto',
      [mediaQuery(1440)]: {
        marginLeft: 40,
      },
      [mediaQuery(1360)]: {
        maxWidth: 'fit-content',
      },
      [mediaQuery(breakpoints.tablet)]: {
        marginLeft: 24,
      },
    },
    list: {
      listStyle: 'none',
      display: 'flex',
      maxWidth: 1360,
      marginInline: 'auto',
    },
    item: {
      alignItems: 'center',
      display: 'flex',
      fontWeight: 500,
      fontSize: 12,
      lineHeight: '16px',
      marginInlineEnd: 8,

      '&:last-child $link': {
        color: ({ whiteText }) => (whiteText ? 'var(--x-bg-1)' : 'var(--x-breadcrumb-last)'),
        cursor: 'initial',
      },
    },
    link: {
      textDecoration: 'none',
      color: ({ whiteText }) => (whiteText ? 'var(--x-bg-1)' : 'var(--x-breadcrumb-normal)'),
    },
    icon: {
      fill: ({ whiteText }) => (whiteText ? 'var(--x-bg-1)' : 'var(--x-textf-field-color-1)'),
    },
    underlineText: {
      textDecoration: 'underline',
      color: ({ whiteText }) => (whiteText ? 'var(--x-bg-1)' : 'var(--x-breadcrumb-normal)'),
    },
    listboxButton: {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: FontWeight.Medium,
      color: 'var(--x-text-color-4)',
    },
    buttonClass: {
      backgroundColor: 'transparent !important',
      padding: '0px !important',
    },
    popoverClass: {
      borderWidth: 0,
      boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.16)',
      '& a': {
        fontWeight: FontWeight.Medium,
        color: 'var(--x-breadcrumb-last)',
        '&:hover': {
          color: 'var(--x-accent-1-1)',
        },
      },
    },
  }),
  { name: 'beardcrumb' },
);
